import { o2oApi } from 'yxt-biz-pc/packages/api';

/**
 * 获取项目信息
 * @param {String} projectId 项目id
 * @returns {Promise} 项目信息
 */
export const getProject = projectId => {
  return o2oApi.get(`project/audit/projectAuditInfo/${projectId}`);
};
